const belgium = [
    { "code": "Bruxelles", "name": "Bruxelles" },
    { "code": "Vlaanderen", "name": "Vlaanderen" },
    { "code": "Région wallonne", "name": "Région wallonne" }
]

export default belgium;